// absolute imports
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

// relative imports
import { isValidLegacyAppId } from '../../../data/app-config/legacyAppIdMapping';

export const Route = createFileRoute('/_authenticated/$appId/$')({
  loader: async ({ params }) => {
    // Validate appId in loader - if invalid, throw notFound
    // Using loader instead of beforeLoad to work with notFoundMode: 'root'
    if (!isValidLegacyAppId(params.appId)) {
      throw notFound();
    }
  },
  beforeLoad: async ({ params, location }) => {
    const { appId } = params;
    const { pathname, search, hash } = location;

    // Skip processing if appId is invalid (loader will handle it)
    if (!isValidLegacyAppId(appId)) {
      return;
    }

    // Extract the path after the appId
    // Example: /tax-preparer/settings -> /settings
    const pathWithoutAppId = pathname.replace(`/${appId}`, '');

    // If the path is just /$appId, redirect to home
    if (pathWithoutAppId === '' || pathWithoutAppId === '/') {
      throw redirect({
        to: '/',
      });
    }

    // Build the redirect with path, search, and hash
    const newPath = pathWithoutAppId;

    // Build redirect options - only include search/hash if they have values
    const redirectOptions: any = {
      to: newPath as any,
    };

    // Only include search if it has values
    if (search && Object.keys(search).length > 0) {
      redirectOptions.search = search;
    }

    // Only include hash if it exists
    if (hash) {
      redirectOptions.hash = hash;
    }

    throw redirect(redirectOptions);
  },
});
